import { BrowserRouter } from "react-router-dom";
import AppRoutes from "../routes/AppRoutes";
import "./App.css";

function App() {
  return (
    <BrowserRouter>
      <div className="app-shell">
        <AppRoutes />
      </div>
    </BrowserRouter>
  );
}

export default App;
